//
//
//
//
//
//

export default {
    name: 'FPS',
    data () {
        return {}
    },
    methods: {},
    created () {
        const href = window.location.href
        window.location.href = href.replace('activity/mylinkActivity/#/FPS', 'mylink/#/other-code')
    }
}



// WEBPACK FOOTER //
// ./src/page/FPS/FPS.vue